<template>
    <va-edit-layout>
        <ShipmentEventShipmentItemTaxWithheldCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></ShipmentEventShipmentItemTaxWithheldCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
